export default __webpack_public_path__ + "static/media/RhymesCountAlong_01.b5daf710.png";